import { useTransformEvent } from '@ion/api';
import { useTransformPlaybookContext } from 'app/context/transform-playbook-context';
import useTrackWithUser from '@ion/api/hooks/useTrackWithUser';

// Basic-mode transform orchestration, lifted verbatim from the pre-chain
// TransformDrawer: run the raw editor playbook against the selected cluster.
export default function useBasicTransform() {
  const { input, clusterId, setIsLoading, playbook, setOutputEvent, setOutputErrors } = useTransformPlaybookContext();
  const [trackOutputEventViewed] = useTrackWithUser('output_event_viewed');

  const [transformEvent] = useTransformEvent({
    onCompleted: ({ errors, outputEvent }) => {
      setIsLoading(false);
      if (errors) {
        setOutputErrors(errors);
      } else {
        setOutputErrors(null);
        setOutputEvent(outputEvent);
      }
    },
    onError: () => {
      // TODO: handle other type of errors
      setIsLoading(false);
    },
  });

  const onClickOutputTab = () => {
    setIsLoading(true);
    transformEvent({ playbook, inputEvent: JSON.parse(input), clusterId });
    trackOutputEventViewed();
  };

  return { onClickOutputTab };
}
